import React, { useState } from "react";
import styled from "styled-components";
import {
    BlockCollab,
    BlockTitleCollab,
    BadgeCollab,
    FieldFull,
    Req,
    TagGroup,
    Tag,
    OptLabel,
    SInput,
} from "../index";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Button, CloseIcon, Flex, Input } from "@fluentui/react-northstar";

export default function BlockEnfants() {
    const [hasChildren, setHasChildren] = useState(false);

    const { control, register } = useFormContext();

    const { fields, append, remove } = useFieldArray({
        control,
        name: "children",
    });

    return (
        <BlockCollab>
            <BlockTitleCollab>
                Enfants <BadgeCollab>À compléter par vous</BadgeCollab>
                <ISNote>(si applicable)</ISNote>
            </BlockTitleCollab>

            <div style={{ marginBottom: 14 }}>
                <FieldFull>
                    <label>
                        Avez-vous des enfants ? <Req>*</Req>
                    </label>
                    <TagGroup>
                        <Tag
                            active={hasChildren}
                            onClick={() => setHasChildren(true)}
                        >
                            Oui
                        </Tag>
                        <Tag
                            active={!hasChildren}
                            onClick={() => setHasChildren(false)}
                        >
                            Non
                        </Tag>
                    </TagGroup>
                </FieldFull>
            </div>
            {hasChildren && (
                <>
                    <ListLabel>
                        Liste des enfants <OptLabel>(si applicable)</OptLabel>
                    </ListLabel>
                    {fields.map((field, index) => {
                        return (
                            <SGrid gap="gap.smaller" key={field.id}>
                                <Flex
                                    vAlign="end"
                                    styles={{ paddingBottom: "10px" }}
                                >
                                    {fields?.length > 1 && (
                                        <CloseIcon
                                            onClick={() => remove(index)}
                                            size="small"
                                            styles={{
                                                color: "var(--text-tert)",
                                                cursor: "pointer",
                                            }}
                                        />
                                    )}
                                </Flex>
                                <SInputSmall
                                    label={"Nom"}
                                    placeholder="--"
                                    {...register(`children.${index}.firstName`)}
                                />
                                <SInputSmall
                                    label={"Prénom"}
                                    placeholder="--"
                                    {...register(`children.${index}.lastName`)}
                                />
                                <SInputSmall
                                    label={"Date de naissance"}
                                    placeholder="--"
                                    type="date"
                                    {...register(`children.${index}.birthdate`)}
                                />
                                <SInputSmall
                                    label={"Parenté"}
                                    placeholder="--"
                                    {...register(
                                        `children.${index}.relationship`
                                    )}
                                />
                                <SInputSmall
                                    label={"Adresse (si différente)"}
                                    placeholder="--"
                                    {...register(`children.${index}.address`)}
                                />
                                <SInputSmall
                                    label={"Autorité parentale"}
                                    placeholder="--"
                                    {...register(
                                        `children.${index}.parental_authority`
                                    )}
                                />
                            </SGrid>
                        );
                    })}
                    <SButtonAddChild
                        text
                        content="+ Ajouter un enfant"
                        onClick={(e) => {
                            e.preventDefault();
                            append({});
                        }}
                        type="button"
                    />
                </>
            )}
        </BlockCollab>
    );
}

const SButtonAddChild = styled(Button)`
    span {
        font-size: 12px;
        color: var(--purple);
        cursor: pointer;
        margin-top: 6px;
        font-weight: 500;
    }
`;
const SGrid = styled.div`
    display: grid;
    grid-template-columns: 15px 1.2fr 1fr 1fr 0.8fr 1.4fr 1fr;
    gap: 6px;
    margin-bottom: 6px;
`;

const ISNote = styled.span`
    font-size: 11px;
    font-weight: 400;
    color: var(--text-tert);
    text-transform: none;
    letter-spacing: 0;
`;

const ListLabel = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: var(--text-sec);
    margin-bottom: 8px;
`;

const SInputSmall = styled(Input)`
    label {
        font-size: 10px;
        color: var(--text-tert);
        font-weight: 600;
    }
    input {
        height: 30px;
        width: 100%;
        background: var(--bg-card);
        border: 1px solid var(--border);
        border-radius: var(--radius-sm);
        padding: 0 8px;
        font-size: 12px;
        display: flex;
        align-items: center;
    }
`;
